/* import __COLOCATED_TEMPLATE__ from './sq-breadcrumb.hbs.js'; */
var _dec, _dec2, _dec3, _class, _class2, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { tagName } from '@ember-decorators/component';
import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import Component from '@ember/component';

/**
## SqBreadcrumb

Displays a dynamic breadcrumb style navigation bar.

```example
@title Example

@controller-properties
{
  breadcrumbStack: [{ label: 'Home', index: 0 }],
  actions: {
    selectBreadcrumb: function(breadcrumb) {
      this.set('breadcrumbStack', this.get('breadcrumbStack').slice(0, breadcrumb.index + 1));
    },
    goDeeper: function() {
      const newIndex = this.get('breadcrumbStack.length');
      this.set('breadcrumbStack', [...this.get('breadcrumbStack'), { label: `Page ${newIndex}`, index: newIndex }])
    }
  },
}

@hbs
{{#sq-breadcrumb breadcrumbs=breadcrumbStack as |breadcrumb isSelectable|}}
  {{~#if isSelectable~}}
    <a {{action "selectBreadcrumb" breadcrumb}}>{{breadcrumb.label}}</a>
  {{~else~}}
    <span>{{breadcrumb.label}}</span>
  {{~/if~}}
{{/sq-breadcrumb}}
<a {{action "goDeeper"}}>Go deeper</a>
```

### Parameters
 * @param {array} breadcrumbs Objects that will be yielded. All but the last one will be yielded with a second parameter, isSelectable, being `true`. For the last one, `isSelectable` is false.

Sass dependencies at: `@square/glass-ui/addon/styles/@square/selector/breadcrumbs/_breadcrumbs.scss`
*/
let SqBreadcrumb = (_dec = tagName('h3'), _dec2 = computed('breadcrumbs.[]'), _dec3 = readOnly('breadcrumbs.lastObject'), _dec(_class = (_class2 = class SqBreadcrumb extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "finalBreadcrumb", _descriptor, this);
  }
  init() {
    super.init();
    if (!this.breadcrumbs) {
      this.set('breadcrumbs', []);
    }
  }
  get selectableBreadcrumbs() {
    const breadcrumbs = this.breadcrumbs;
    return breadcrumbs.slice(0, -1);
  }
}, (_applyDecoratedDescriptor(_class2.prototype, "selectableBreadcrumbs", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "selectableBreadcrumbs"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "finalBreadcrumb", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
export { SqBreadcrumb as default };